/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconPointerSearch = createReactComponent("pointer-search", "IconPointerSearch", [
  [
    "path",
    {
      d: "M14.778 12.222l3.113 -2.09a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093",
      key: "svg-0"
    }
  ],
  ["path", { d: "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-1" }],
  ["path", { d: "M20.2 20.2l1.8 1.8", key: "svg-2" }]
]);

export { IconPointerSearch as default };
//# sourceMappingURL=IconPointerSearch.js.map
